(function () {
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCounter(el) {
    if (el.dataset.counterDone === 'true') return;
    const target = parseFloat(el.dataset.target, 10);
    const valueEl = el.querySelector('.stats-column-number__value');
    if (!valueEl || Number.isNaN(target)) return;

    const duration = parseInt(el.dataset.duration, 10) || 2000;
    const delay = parseInt(el.dataset.delay, 10) || 0;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      valueEl.textContent = String(Math.round(target));
      el.dataset.counterDone = 'true';
      return;
    }

    el.dataset.counterDone = 'true';

    function run() {
      const start = performance.now();
      function frame(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutCubic(progress);
        const current = Math.round(eased * target);
        valueEl.textContent = String(current);
        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          valueEl.textContent = String(Math.round(target));
        }
      }
      requestAnimationFrame(frame);
    }

    if (delay > 0) {
      setTimeout(run, delay);
    } else {
      run();
    }
  }

  function initSection(section) {
    const numbers = section.querySelectorAll('.stats-column-number[data-target]');
    if (!numbers.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    numbers.forEach((el) => observer.observe(el));
  }

  document.querySelectorAll('[data-stats-column-root]').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-stats-column-root]');
    if (root) initSection(root);
  });
})();
